import React from 'react';
import {
  IconButton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  useToast,
  TableCaption,
} from '@chakra-ui/react';
import { CopyIcon } from '@chakra-ui/icons';

import {
  copyQuoteTable,
  defaultValueSelector,
  priceForCell,
  QuoteMatrixProps,
  sampleSizeLabel,
} from './utils';

export default function QuoteListSection(props: QuoteMatrixProps) {
  const {
    numberOfQuestions,
    sampleSizes,
    quotes,
    calculatedMaxRecommendedSampleSize,
  } = props;
  const toast = useToast();

  const handleCopy = async () => {
    try {
      await copyQuoteTable(props);
      toast({
        title: 'Quote',
        description: 'Copied quote to clipboard!',
        status: 'info',
        duration: 5000,
        isClosable: true,
      });
    } catch {
      toast({
        title: 'Quote',
        description: 'Could not copy the quote to your clipboard.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <TableContainer>
      <Table size="sm" variant="striped">
        <TableCaption
          placement="top"
          backgroundColor="brand.tableTitleColor"
          textColor="brand.bodyText"
          fontSize="lg"
        >
          Quote
          <IconButton
            aria-label="Copy quote to clipboard"
            variant="ghost"
            color="brand.linkColor"
            marginLeft={10}
            onClick={handleCopy}
          >
            <CopyIcon />
          </IconButton>
        </TableCaption>
        <Thead>
          <Tr>
            <Td textAlign="center" fontWeight="bold">
              Respondents
            </Td>
            {sampleSizes.map((value, index) => {
              const key = `${value}-${index}`;
              return (
                <Td textAlign="center" fontWeight="bold" key={key}>
                  {sampleSizeLabel(value)}
                </Td>
              );
            })}
          </Tr>
        </Thead>
        <Tbody>
          {numberOfQuestions.map((questionCount) => (
            <Tr key={questionCount}>
              <Td textAlign="center">
                <strong>{`${questionCount} Question Poll`}</strong>
              </Td>
              {sampleSizes.map((sampleValue) => (
                <Td
                  textAlign="center"
                  key={`${questionCount}-${sampleValue}`}
                  color={
                    sampleValue > calculatedMaxRecommendedSampleSize
                      ? 'emphasisTextColor'
                      : 'current'
                  }
                >
                  {priceForCell(
                    quotes,
                    questionCount,
                    sampleValue,
                    defaultValueSelector,
                  )}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
